import type { ReviewAnalyticsTabApi } from "@/types/analytics-reviews";
import type { ReviewsSegment } from "./types";

export const REVIEWS_SEGMENT_OPTIONS: {
  value: ReviewsSegment;
  label: string;
}[] = [
  { value: "reservations", label: "Reservations" },
  { value: "requests", label: "Requests" },
  { value: "communication", label: "Communication" },
];

export const DEFAULT_REVIEWS_SEGMENT: ReviewsSegment = "reservations";

export const SEGMENT_TO_REVIEW_TAB: Record<
  ReviewsSegment,
  ReviewAnalyticsTabApi
> = {
  reservations: "RESERVATIONS",
  requests: "REQUESTS",
  communication: "COMMUNICATIONS",
};

export function isReviewsSegment(value: string): value is ReviewsSegment {
  return REVIEWS_SEGMENT_OPTIONS.some((option) => option.value === value);
}

export function parseReviewsSegment(raw: string | null): ReviewsSegment {
  if (raw && isReviewsSegment(raw)) {
    return raw;
  }

  return DEFAULT_REVIEWS_SEGMENT;
}
